












































































































































import PageWithMainContainer from "@/components/PageWithMainContainer.vue";
import VirtualTable from "@/components/table/VirtualTable.vue";
import SelectSessionBtn from "@/views/customize/data-sources/modals/source-details/SelectSessionBtn.vue";
import { onMounted } from "@vue/composition-api";
import Vue from "vue";
import { state } from "./data/state";
import { table_config } from "./table.config";
import S3TableRow from "./S3TableRow.vue";
import { UseModal } from "@/components/root/modal";
import ContentLabelTreeModalVue from "../../common/info-types-modal/ContentLabelTreeModal.vue";
import ThemeImg from "@/components/ThemeImg.vue";
import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";
export default Vue.extend({
  components: {
    PageWithMainContainer,
    SelectSessionBtn,
    VirtualTable,
    ThemeImg,
    SkeletonLoaderItem,
  },
  setup() {
    const {
      loading,
      s3_row_items,
      save_selected_labels_ids,
      selected_labels_count,
      selected_session,
      sessions,
      set_selected_session,
      s3_bucket_items,
      selected_s3_row_item,
      set_selected_s3_row_item,
      selected_labels,
    } = state;

    const open_new_session_modal = async () => {
      const { state: data_sources } = await import(
        "@/views/customize/data-sources/data/state"
      );
      const res = await data_sources.ext.open_scan_session_modal_for_source(
        "amazon_s3"
      );
      if (res == "refresh") {
        state.init(true);
      }
    };

    const show_labels_modal = async () => {
      const res = await UseModal().show(ContentLabelTreeModalVue, {
        labels: selected_labels.value,
      });
      if (res.type == "success") {
        // @ts-ignore
        const selected_labels_ids = res.msg as string[];
        save_selected_labels_ids(selected_labels_ids);
      }
    };

    const {
      is_loading,
      items,
      has_no_results,
      load_more_items,
    } = s3_bucket_items;

    onMounted(() => {
      state.init();
    });
    return {
      loading,
      s3_row_items,
      save_selected_labels_ids,
      selected_labels_count,
      selected_session,
      sessions,
      set_selected_session,
      open_new_session_modal,

      selected_s3_row_item,
      set_selected_s3_row_item,
      table_config,
      S3TableRow,
      is_loading,
      items,
      has_no_results,
      load_more_items,
      show_labels_modal,
    };
  },
});
